import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../index";
import { GET_EMPLOYEE_PERFORMANCE, GET_OPERATION_EMPLOYEE_PERFORMANCE } from "../Queries/EmployeePerformance";

export const fetchEmployeePerformanceStatsAsync = createAsyncThunk(
  "employeePerformance/fetchStats",
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_EMPLOYEE_PERFORMANCE,
        variables: { startDate, endDate },
        fetchPolicy: "no-cache",
      });

      return data.EmployeePerformanceStats;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch stats");
    }
  }
);

export const fetchEmployeePerformanceAsync = createAsyncThunk(
  "employeePerformance/fetchEmployeeView",
  async ({ employeeId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_OPERATION_EMPLOYEE_PERFORMANCE,
        variables: { employeeId, startDate, endDate },
        fetchPolicy: "no-cache",
      });

      return data.EmployeeViewPerformance;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch employee view");
    }
  }
);

const employeePerformanceSlice = createSlice({
  name: "employeePerformance",
  initialState: { performanceData: [], loading: false, error: null },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeePerformanceStatsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeePerformanceStatsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.performanceData = action.payload;
      })
      .addCase(fetchEmployeePerformanceStatsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchEmployeePerformanceAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeePerformanceAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.performanceData = action.payload;
      })
      .addCase(fetchEmployeePerformanceAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default employeePerformanceSlice.reducer;
